import { TrialOptionFilter } from '../types';

export const isSchedulingFilter = (filter: TrialOptionFilter): boolean => {
  return [
    TrialOptionFilter.ScheduledAll,
    TrialOptionFilter.ScheduledToday,
    TrialOptionFilter.ScheduledWeek,
  ].includes(filter);
};
